import { MofoPromiseBar } from "../components/mofo-promise-bar";

const test = ({
  __typename,
  staticType,
}: {
  __typename: string;
  staticType: string;
}): boolean =>
  __typename === "VinoData_StaticBlock" && staticType === "Mofo promise bar";

const create = (): JSX.Element => {
  return <MofoPromiseBar />;
};

export default { test, create };
